import styled from 'vue-styled-components';

import theme from '@/config/theme';

const Wrapper = styled.label`
  cursor: pointer;
  display: inline-block;
  position: relative;
  user-select: none;

  .label {
    align-items: center;
    color: ${theme.colors.gray6};
    display: flex;
    font-size: ${theme.font.sizes.p2};
    height: 24px;
    padding-left: 36px;
    transition: .25s;
  }

  > input {
    cursor: pointer;
    height: 0;
    opacity: 0;
    position: absolute;
    width: 0;

    &:checked ~ .checkmark {
      background-color: ${theme.colors.white};

      &:after {
        background-color: ${theme.colors.primary};
        border-color: ${theme.colors.primary};
        display: block;
      }
    }

    /* &:disabled ~ .label {
      color: ${theme.colors.gray1}
    } */

    &:disabled ~ .checkmark {
      border-color: ${theme.colors.gray1};
    }
  }

  > .checkmark {
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray6};
    border-radius: ${theme.border.radius.circle};
    left: 0;
    height: 24px;
    position: absolute;
    top: 0;
    width: 24px;
    transition: .25s;

    &:after {
      border-radius: ${theme.border.radius.circle};
      content: "";
      display: none;
      height: 14px;
      left: 4px;
      position: absolute;
      top: 4px;
      width: 14px;
    }
  }

  &:hover > input:not(:checked):not(:disabled) {

    ~ .label {
      color: ${theme.colors.primary};
    }

    ~ .checkmark {
      border-color: ${theme.colors.primary};
      box-shadow: ${theme.shadow.btDefault};
    }
  }
`;

export default Wrapper;
